import { useCallback } from 'react';

import { Sizes } from '@dbt-labs/sourdough';
import { Button } from '@dbt-labs/sourdough';

import { NodeFilters, useFilterContext } from '@/context/FilterProvider';

type FilteredNodeFilters = Pick<
  NodeFilters,
  | 'platforms'
  | 'environmentTypes'
  | 'searchFields'
  | 'materialization'
  | 'modelingLayer'
  | 'access'
  | 'projects'
  | 'warehouseAssetTypes'
  | 'resourceType'
>;

export const ClearSelectAllButton = <
  T extends keyof FilteredNodeFilters,
  K extends FilteredNodeFilters[T],
>({
  selectedList,
  selectionList,
  type,
}: {
  selectedList?: K;
  selectionList: { label: string; value: K extends Array<infer U> ? U : K }[];
  type: T;
}) => {
  const filterCtx = useFilterContext();
  const isClear = selectedList?.length === selectionList.length;
  const handleClearSelectAll = useCallback(() => {
    filterCtx.updateFilters(
      {
        [type]: selectionList.map(({ value }) => value),
      },
      !isClear,
    );
  }, [filterCtx, selectionList, type, isClear]);

  return (
    <Button
      type="tertiary"
      className="mt-1 !p-0"
      size={Sizes.sm}
      text={isClear ? 'Clear' : 'Select All'}
      onClick={handleClearSelectAll}
    />
  );
};
